import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IYii} from '../../../globals';
import {FormService} from '../services/FormService';
import {FormEditableSharedComponent} from './form-editable-shared';
import {FormAllowDownloadComponent} from './form-allow-download';
import {FormPDFComponent} from './form-pdf';
import {FormHybrydPDFComponent} from './form-hybryd-pdf';
import {FormSignflowComponent} from './form-signflow';
import {FormCaptureLocationComponent} from './form-capture-location';
import {FormTypeComponent} from './form-type';
import {FormLogoComponent} from './form-logo';
import {FormGeneral} from './form-general';

declare var Yii: IYii;

@Component({
  selector: 'ng-edit-properties-tab',
  standalone: true,
  imports: [
    CommonModule,
    FormEditableSharedComponent,
    FormAllowDownloadComponent,
    FormPDFComponent,
    FormHybrydPDFComponent,
    FormSignflowComponent,
    FormCaptureLocationComponent,
    FormTypeComponent,
    FormLogoComponent,
    FormGeneral
  ],
  template: `
    <div>
      @if (fsvc.form.isHTMLForm) {
        <div class="alert alert-info">
          <i class="fa fa-info-circle fa-2x" style="vertical-align: bottom;"></i>
          <span style="line-height: 28px">
            As this form is customly built HTML <i class="fa fa-html5"></i> form - there are some limitations on its configuration
          </span>
        </div>
      }
      <div class="flex-row">
        <div class="flex-grow-1" style="width: 50%">
          <ng-form-general></ng-form-general>
          <ng-form-editable-shared></ng-form-editable-shared>
          <ng-form-allow-download></ng-form-allow-download>
          <ng-form-pdf></ng-form-pdf>
        </div>
        <div class="flex-grow-1" style="width: 50%">
          <ng-form-signflow></ng-form-signflow>
          <ng-form-capture-location></ng-form-capture-location>
          <ng-form-type></ng-form-type>
          <ng-form-logo></ng-form-logo>
        </div>
      </div>
      <ng-form-hybryd-pdf></ng-form-hybryd-pdf>
    </div>
  `
})
export class FormPropertiesTab {
  Yii = Yii;

  constructor(public fsvc: FormService) {
  }
}
